import { message, Modal } from "antd";
import React from "react";
import CommonFunctions from "../../Shared/CommonFunctions";
import enrollmentServices from "../../../Services/enrollmentServices";

const PayAgain = ({ record, appointmentsList }) => {
  const [showPayModal, setShowPayModal] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const storedLoginResult = sessionStorage.getItem("login_result");
  const loggedUser = storedLoginResult ? JSON.parse(storedLoginResult) : null;

  const handleProceedPayment = async (payType) => {
    setLoader(true);
    const now = CommonFunctions.convertUTCDate(
      new Date(),
      "YYYY-MM-DD HH:mm:ss",
    );

    let data = {
      ...record,
      paymentType: payType,
      modifiedBy: loggedUser.user.userId,
      modifiedDate: now,
      status: 0,
      paymentReceived: "N",
      consultationFee: record?.consultationFee || record?.totalAmount,
      mobile: record?.mobile || record?.mobileNumber,
    };

    if (payType === "Digital") {
      CommonFunctions.ExisTingPatientPayment(data)
        .then(() => {
          if (loggedUser?.user?.currencyCode != "INR") {
            message.success("Payment  Successfull");
            if (appointmentsList) {
              appointmentsList();
            }
            // fetchAllAppts();
            setShowPayModal(false);
            return;
          }
        })
        .catch((error) => {
          console.error("An error occurred:", error);
          setLoader(false);
          message.error("An Error occurred, try again");
        })
        .finally(() => {
          setLoader(false);
        });
    } else if (payType === "link") {
      const payload = {
        shareLinkTransId: record?.shareLinkTransId,
      };
      try {
        const result = await enrollmentServices.sharePaymentLink(payload);

        if (result.data === 1) {
          message.success("Payment Link and invitation sent Successfully");
          // fetchAllAppts();
          setLoader(false);
          setShowPayModal(false);

          return;
        }
      } catch (e) {
        message.error("Something went wrong. Please try after sometime!!");
        setLoader(false);
      }
    }
  };
  const handleClosePayModal = () => {
    setShowPayModal(false);
  };

  const handleShowPayModal = async () => {
    setShowPayModal(true);
  };

  return (
    <>
      {!record.transactionId && (
        <button
          onClick={handleShowPayModal}
          className="bg-brand-primaryColor text-white w-28 p-2 text-cen4 rounded-md"
        >
          Pay Now
        </button>
      )}
      <Modal
        title="Pay now"
        open={showPayModal}
        onCancel={handleClosePayModal}
        footer={[]}
        destroyOnClose
        width={"30%"}
      >
        <div className={`w-full`}>
          <div>
            <div className="w-full flex justify-between items-center my-1">
              <span>Consultation Fee :</span>
              <span>
                <span className="text-sm font-normal text-gray-400 mr-0.5">
                  {loggedUser?.user?.currencyCode
                    ? loggedUser?.user?.currencyCode
                    : ""}
                </span>
                {record?.totalAmount}
              </span>
            </div>
            <div className="w-full flex justify-between items-center my-1 mb-2">
              <span>Total :</span>
              <div>
                <span>
                  <span className="text-sm font-normal text-gray-400 mr-0.5">
                    {loggedUser?.user?.currencyCode
                      ? loggedUser?.user?.currencyCode
                      : ""}
                  </span>
                  {record?.totalAmount}
                </span>
              </div>
            </div>
            <p>Payment Options :</p>
            <div className="m-6">
              <button
                disabled={loader}
                className="py-2 min-w-full w-36 mb-2 text-sm font-semibold text-white bg-cyan-600 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => handleProceedPayment("Digital")}
              >
                Digital
              </button>
              <button
                disabled={loader || loggedUser?.user?.currencyCode != "INR"}
                onClick={() => handleProceedPayment("link")}
                className="py-2 min-w-full w-36 mb-2 text-sm font-semibold text-white bg-cyan-600 rounded disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Share payment link
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PayAgain;
